import Navbar from "../../components/navbar";
import grupo from "../../utils/grupo-de-empresarios-diversos-que-trabalham-juntos-num-escritorio-moderno-conceito-de-trabalho-em-equipa.jpg";
import dados from "../../utils/dados";
import logoDW from "../../utils/help tech.png";

const Contatos = () => {
  return (
    <>
      <Navbar />
      <div className="container_menu">
        <div className="colum1">
          <div className="sobre-nos">
            <h1 className="H1">Sobre Nós</h1>
            <p className="text">
              <br />
              Somos uma extensão da empresa Digital While, nosso foco é fazer
              uma busca pelos maiores ecommerces e garimpar os melhores produtos
              para nossos clientes, assim como também negociamos cupons de
              desconto e promoções exclusivas!
            </p>
            <br />
            <p className="text">
              Caso tenha alguma dúvida ou pergunta, ficamos felizes em
              responde-las, entre em contato através de nossas redes sociais ou
              mande uma mensagem para nosso WhatsApp!{" "}
            </p>
            <br />
            <br />
            <div className="contatos">
              <a
                href={dados.ajuda_wpp}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="https://t.ctcdn.com.br/qpEUCT2UXKOK2-JrsqjvFvbd1A4=/i618809.png"
                  alt="logo do whatsapp com o link de ajuda"
                  className="icones"
                />
              </a>
              <a
                href={dados.instagram.link}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a5/Instagram_icon.png/600px-Instagram_icon.png"
                  alt={dados.instagram.nome}
                  className="icones"
                />
              </a>
              <a
                href={dados.tiktok.link}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="https://i.em.com.br/H3WhcCyGzdhf2L2A8tvVvGrlIfw=/1200x1200/smart/imgsapp.em.com.br/app/noticia_127983242361/2023/05/23/1497370/logo-tiktok_1_26811.jpeg"
                  alt={dados.tiktok.nome}
                  className="icones"
                />
              </a>
              <a
                href={dados.digital_while.site}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={logoDW}
                  alt="Site da Digital While"
                  className="icones"
                />
              </a>
            </div>
          </div>
          <img
            className="equipe-foto"
            src={grupo}
            alt="grupo de pessoas no escritório"
          />
        </div>
      </div>
      <footer>
        ©Todos os direitos reservados. | CNPJ: 50.133.965/0001-20 - Extensão da
        Digital While.
      </footer>
    </>
  );
};

export default Contatos;
